import { Injectable } from '@angular/core';
import { Deserializable } from '../../common/utility/deserializable.model';
import { PaymentPlanDefaults } from '../model/payment-plan';
import { HttpParams } from '@angular/common/http';
import { RESTService } from 'src/app/common/services/rest.service';

@Injectable({
    providedIn: 'root'
})
export class PaymentHubService {

    static _instance: PaymentHubService;

    constructor(private restService: RESTService) {
        this._defaults = null;
        console.log('Called');
    }

    _defaults: PaymentPlanDefaults;

    // Default operations.
    defaults(transactionId: string) {
        const parameters = new HttpParams().set(RESTService.REQUEST_PARAM_TRANSACTION_ID, transactionId);
        return this.restService.get('/defaults', parameters);
    }

    branding() {
        const parameters = new HttpParams().set(RESTService.REQUEST_PARAM_TRANSACTION_ID, localStorage.getItem(PaymentPlanDefaults.CONSTANT_TRANSACTION_ID));
        return this.restService.get('/branding', parameters);
    }
}


@Injectable({
    providedIn: 'root'
})
export class PaymentHubDefaults {
    paymentHubService: PaymentHubService;

    brands: any;

    constructor(paymentHubService: PaymentHubService) {
        this.paymentHubService = paymentHubService;
        this.loadBranding();
    }

    loadBranding() {
        this.paymentHubService.branding().subscribe(res => {
            if (res.status !== 200) {
                alert(res.body);
                return;
            }
            this.brands = res.body;
        }, err => {
            console.log(err);
            alert(err.error.message);
        });
    }
}
